class LegacyBundleSelect {
  constructor() {
    
    this.header = document.querySelector(".shopify-section-group-header-group");
    this.overlay = document.querySelector(".js-bundle-select-options-overlay");
    if (this.overlay == void 0 || window.screen.width > 768) return;
    this.closeBtn = this.overlay.querySelector("[data-close-button]");
    this.genderFiltersWrapper = this.overlay.querySelector("[data-gender-filters]");
    this.genderFilters = this.genderFiltersWrapper.querySelectorAll("[data-gender-filter]");
    this.fragranceWrappers = this.overlay.querySelectorAll("[data-fragrance-wrapper]");
    this.submitButtonWrapper = this.overlay.querySelector("[data-submit-button]");
    this.selectFields = document.querySelectorAll(".js-bundle-select");
    this.searchField = this.overlay.querySelector("[data-search-field]");
    this.searchButton = this.overlay.querySelector("[data-search-button]");
    this.clearSearch = this.overlay.querySelector("[data-clear-search]");
    this.selectBoxButtons = document.querySelectorAll("[data-search-box-replacement]");
    this.productLimit = window.maxLimit || 3;
    this.selectedProducts = [];
    this.initEventListeners();
    console.log('hello');
  }
  initEventListeners() {
    console.log('hello');
    this.selectBoxButtons.forEach((select) => {
      ["click"].forEach((eventType) => {
        select.addEventListener(eventType, (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleOverlay(select, e);
        });
      });
    });
    this.selectFields.forEach((select) => {
      select.parentElement.querySelector(".js-bundle-select-search-icon").classList.remove("hidden");
      ["click"].forEach((eventType) => {
        select.addEventListener(eventType, (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleOverlay(select, e);
        });
      });
    });
    this.closeBtn.addEventListener("click", (e) => {
      this.toggleOverlay();
    });
    this.genderFilters.forEach((filter) => {
      filter.addEventListener("click", (e) => {
        this.toggleGenderFilter(filter);
      });
    });
    this.fragranceWrappers.forEach((fragranceWrapper) => {
      fragranceWrapper.querySelector("button[data-quantity-add").addEventListener("click", (e) => {
        e.preventDefault();
        console.log(e.target.parentElement, e.target.parentElement.querySelector("input"));
        e.target.parentElement.querySelector("input").value++;
        this.updateSelectedProducts();
      });
      fragranceWrapper.querySelector("button[data-quantity-remove").addEventListener("click", (e) => {
        e.preventDefault();
        e.target.parentElement.querySelector("input").value--;
        this.updateSelectedProducts();
      });
      fragranceWrapper.querySelector('input[type="checkbox"]').addEventListener("click", (e) => {
        this.updateSelectedProducts();
      });
    });
    this.submitButtonWrapper.querySelector("button").addEventListener("click", (e) => {
      e.preventDefault();
      this.updateSelectOptions();
    });
    this.searchField.addEventListener("keyup", (e) => {
      e.preventDefault();
      this.search();
    });
    this.searchField.addEventListener("input", (e) => {
      if (e.target.value.length === 0) {
        this.search();
      }
    });
    this.clearSearch.addEventListener("click", (e) => {
      e.preventDefault();
      this.searchField.value = "";
      this.searchField.focus();
      this.search();
    });
    this.genderFilters[0].click();
  }
  updateSelectOptions() {
    this.selectFields.forEach((select, i) => {
      if (this.selectedProducts[i] !== void 0) {
        let selectedOption = this.selectedProducts[i].querySelector('input[type="checkbox"]').value;
        select.querySelectorAll("option").forEach((option) => {
          if (option.value === selectedOption) {
            option.selected = true;
          } else {
            option.selected = false;
          }
        });
      }
      this.selectBoxButtons[i].querySelector("[data-selected-product]").innerText = this.selectedProducts[i].querySelector('input[type="checkbox"]').value;
    });
    document.querySelector('#AddToCart').click();
    this.toggleOverlay();
  }
  updateSelectedProducts() {
    this.selectedProducts = [];
    this.fragranceWrappers.forEach((fragranceWrapper) => {
      const checkbox = fragranceWrapper.querySelector('input[type="checkbox"]');
      let quantity = checkbox.parentElement.querySelector("[data-quantity-selector]").querySelector("input").value;
      if (checkbox.checked && quantity > 0) {
        checkbox.classList.add("hidden");
        checkbox.parentElement.querySelector("[data-quantity-selector]").classList.remove("hidden");
        fragranceWrapper.classList.remove("border-white");
        fragranceWrapper.classList.add("border-[#ef776b]");
        console.log("QUANTITY: ", quantity);
        for (let i = 0; i < quantity; i++) {
          this.selectedProducts.push(fragranceWrapper);
        }
      } else {
        fragranceWrapper.classList.add("border-white");
        fragranceWrapper.classList.remove("border-[#ef776b]");
        checkbox.checked = false;
        checkbox.classList.remove("hidden");
        checkbox.parentElement.querySelector("[data-quantity-selector]").classList.add("hidden");
        checkbox.parentElement.querySelector("[data-quantity-selector]").querySelector("input").value = 1;
      }
    });
    this.submitButtonWrapper.querySelector("[data-total-selected]").innerHTML = this.selectedProducts.length;
    if (this.selectedProducts.length === this.productLimit) {
      this.overlay.querySelector("[data-discount-notification]").classList.remove("hidden");
      this.fragranceWrappers.forEach((fragranceWrapper) => {
        const checkbox = fragranceWrapper.querySelector('input[type="checkbox"]');
        if (!checkbox.checked) {
          fragranceWrapper.classList.add("opacity-30", "pointer-events-none");
        }
        fragranceWrapper.querySelector("button[data-quantity-add").classList.add("hidden");
      });
      this.submitButtonWrapper.querySelector("button").disabled = false;
      this.submitButtonWrapper.querySelector("[data-submit-label]").classList.remove("hidden");
      this.submitButtonWrapper.querySelector("[data-submit-counter]").classList.add("hidden");
    } else {
      this.fragranceWrappers.forEach((fragranceWrapper) => {
        fragranceWrapper.querySelector("button[data-quantity-add").classList.remove("hidden");
        fragranceWrapper.classList.remove("opacity-30", "pointer-events-none");
      });
      this.selectBoxButtons.forEach((button) => {
        button.classList.remove("hidden");
      });
      this.submitButtonWrapper.querySelector("button").disabled = true;
      this.submitButtonWrapper.querySelector("[data-submit-label]").classList.add("hidden");
      if (this.selectedProducts.length == 0) {
        this.submitButtonWrapper.querySelector("[data-initial-prompt]").classList.remove("hidden");
        this.submitButtonWrapper.querySelector("[data-submit-counter]").classList.add("hidden");
      } else {
        this.submitButtonWrapper.querySelector("[data-initial-prompt]").classList.add("hidden");
        this.submitButtonWrapper.querySelector("[data-submit-counter]").classList.remove("hidden");
      }
      this.overlay.querySelector("[data-discount-notification]").classList.add("hidden");
    }
    if(document.querySelectorAll(".mrk-new-bundle-wrapper").length){
      document.querySelectorAll(`.mrk-bundle-item-main-wrapper`).forEach(function(item){
        item.classList.remove('mrk-bottle-active');
        item.querySelector('[data-selected-product]').innerText = 'Search..';
      })
      this.selectedProducts.forEach(function(item, index){
        index = index + 1;
        var title = item.querySelector('.mrk-product-title').getAttribute('title');
        document.querySelector(`.mrk-bundle-item-main-wrapper[data-index="${index}"]`).classList.add('mrk-bottle-active');
        document.querySelector(`.mrk-bundle-item-main-wrapper[data-index="${index}"] [data-selected-product]`).innerText = title;
      })
    }
  }
  toggleOverlay() {
    document.querySelector("body").classList.toggle("overflow-hidden");
    this.header.classList.toggle("sticky");
    this.overlay.classList.toggle("hidden");
  }
  toggleGenderFilter(filter) {
    this.genderFilters.forEach((genderFilter) => {
      genderFilter.classList.remove("border-b-black", "text-black");
      genderFilter.classList.add("border-b-gray-200");
    });
    filter.classList.remove("border-b-gray-200");
    filter.classList.add("border-b-black", "text-black");
    const selectedGender = filter.dataset.genderFilter.toLowerCase();
    this.fragranceWrappers.forEach((fragranceWrapper) => {
      const genders = fragranceWrapper.dataset.gender.toLowerCase().split(",").map((gender) => gender.trim());
      if (genders.includes(selectedGender) || selectedGender === "all") {
        fragranceWrapper.classList.remove("hidden");
      } else {
        fragranceWrapper.classList.add("hidden");
      }
    });
  }
  search() {
    let searchValue = this.searchField.value.toLowerCase();
    document.querySelector("[data-no-results]").classList.add("hidden");
    if (searchValue.length === 0) {
      this.fragranceWrappers.forEach((fragranceWrapper) => {
        fragranceWrapper.classList.remove("hidden");
      });
      this.genderFiltersWrapper.classList.remove("hidden");
      return;
    }
    this.genderFiltersWrapper.classList.add("hidden");
    let hiddenWrappers = 0;
    this.fragranceWrappers.forEach((fragranceWrapper) => {
      if (fragranceWrapper.dataset.fragrance.toLowerCase().includes(searchValue)) {
        fragranceWrapper.classList.remove("hidden");
      } else {
        fragranceWrapper.classList.add("hidden");
        hiddenWrappers++;
      }
    });
    console.log(hiddenWrappers, this.fragranceWrappers.length);
    if (hiddenWrappers == this.fragranceWrappers.length) {
      document.querySelector("[data-no-results]").classList.remove("hidden");
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  new LegacyBundleSelect();
});